import React from 'react';
import { ConsultationCard } from './ConsultationCard';
import { TabType } from '../screens/DashboardScreen';
import { UrgentConsulting } from '../types/api';

interface ConsultationListProps {
  consultations: UrgentConsulting[];
  tabType: TabType;
}

export const ConsultationList: React.FC<ConsultationListProps> = ({
  consultations,
  tabType,
}) => {
  if (consultations.length === 0) {
    return (
      <div className="bg-white rounded-xl p-8 text-center shadow-sm">
        <div className="w-16 h-16 mx-auto mb-4 bg-primaryBg rounded-full flex items-center justify-center">
          <svg className="w-8 h-8 text-grayText" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-blackText mb-2">
          No consultations found
        </h3>
        <p className="text-grayText text-sm">
          {tabType === 'open' && 'No open consultations at the moment.'}
          {tabType === 'needPatientMeeting' && 'No consultations waiting for patient meetings.'}
          {tabType === 'done' && 'No completed consultations to show.'}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {consultations.map((consultation) => (
        <ConsultationCard
          key={consultation.id}
          consultation={consultation}
          tabType={tabType}
        />
      ))}
    </div>
  );
};